import React, { useContext, useEffect, useState } from 'react'
import AddCircle from '@mui/icons-material/AddCircle'
import AddAgendaPopup from './AddAgendaPopup'
import BigModal from '../../../../components/Modals/BigModal'

import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import { Stack } from '@mui/material'
const MeetingAgenda = ({ agendaItems, setOpenAddAgendaPopup, meetingType }) => {
  return (
    <Paper sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title3">Agenda</Typography>
        </Grid>
        <Grid item xs={12}>
          <CustomDataGrid
            rows={agendaItems}
            columns={[
              { field: 'title', headerName: 'Title', minWidth: 200, flex: 1 },
              {
                field: 'description',
                headerName: 'Description',
                minWidth: 200,
                flex: 0.8,
              },
              {
                field: 'lead',
                headerName: 'Lead',
                minWidth: 150,
                renderCell: ({ row }) => (
                  <Box
                    display="flex"
                    height="100%"
                    width="100%"
                    alignItems="center"
                  >
                    <Stack direction="row" flexWrap="wrap" gap={1}>
                      {row.lead.map((x) => (
                        <Tooltip title={x.firstName + ' ' + x.lastName}>
                          <Avatar
                            src={x?.photograph}
                            sx={{ width: 32, height: 32, borderRadius: 1 }}
                          >
                            {x.firstName[0] + x.lastName[0]}
                          </Avatar>
                        </Tooltip>
                      ))}
                    </Stack>
                  </Box>
                ),
              },
              ...(meetingType === 'Governance'
                ? [
                    {
                      field: 'cqcQualityStatement',
                      headerName: 'CQC',
                      minWidth: 100,
                    },
                  ]
                : []),
              {
                field: 'estimatedTime',
                headerName: 'Estimated Time',
                renderCell: ({ row }) => row + ' mins',
              },
            ]}
            getRowId={(row) => row.title}
            slots={{
              noRowsOverlay: () => (
                <Alert sx={{ zIndex: 10 }} severity="warning">
                  No Agenda Items Yet
                </Alert>
              ),
              toolbar: () => null,
              footer: () => null,
            }}
            maxHeight={300}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="center">
            <Button
              onClick={() => setOpenAddAgendaPopup(true)}
              startIcon={<AddCircle />}
              variant="outlined"
              size="small"
              fullWidth
            >
              Add Item
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default MeetingAgenda
